var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfSmf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3170_64659)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3170_64659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "#F5F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "url(#paint0_linear_3170_64659)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "#2C87BB",
    fillOpacity: 0.88
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 3.44434H9.75C9.3375 3.44434 9 3.58898 9 3.76576V7.62291C9 7.79969 9.3375 7.94434 9.75 7.94434H20.25C20.6625 7.94434 21 7.79969 21 7.62291V3.76576C21 3.58898 20.6625 3.44434 20.25 3.44434ZM15.375 5.69434H19.125C19.335 5.69434 19.5 5.52934 19.5 5.31934C19.5 5.10934 19.335 4.94434 19.125 4.94434H15.375C15.165 4.94434 15 5.10934 15 5.31934C15 5.52934 15.165 5.69434 15.375 5.69434ZM10.5 5.19434C10.5 4.91819 10.7239 4.69434 11 4.69434H11.5C11.7761 4.69434 12 4.91819 12 5.19434C12 5.47048 11.7761 5.69434 11.5 5.69434H11C10.7239 5.69434 10.5 5.47048 10.5 5.19434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 7.94434L14.625 13.9443C14.625 14.3643 14.79 14.6943 15 14.6943C15.21 14.6943 15.375 14.3643 15.375 13.9443L15.375 7.94434C15.375 7.52434 15.21 7.19434 15 7.19434C14.79 7.19434 14.625 7.52434 14.625 7.94434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 13.1943H12.375C12.1687 13.1943 12 13.2667 12 13.3551V15.2836C12 15.372 12.1687 15.4443 12.375 15.4443H17.625C17.8313 15.4443 18 15.372 18 15.2836V13.3551C18 13.2667 17.8313 13.1943 17.625 13.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 14.1943,
    x2: 20.5,
    y2: 14.1943,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3125 10.1943H13.6875C13.5844 10.1943 13.5 10.3149 13.5 10.4622V13.6765C13.5 13.8238 13.5844 13.9443 13.6875 13.9443H16.3125C16.4156 13.9443 16.5 13.8238 16.5 13.6765V10.4622C16.5 10.3149 16.4156 10.1943 16.3125 10.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96729 24.4302C9.96729 24.2476 9.92969 24.0864 9.85449 23.9468C9.7793 23.8071 9.67367 23.6818 9.5376 23.5708C9.39437 23.467 9.22428 23.3739 9.02734 23.2915C8.83398 23.2056 8.61735 23.1286 8.37744 23.0605C8.00863 22.9567 7.66846 22.8296 7.35693 22.6792C7.04899 22.5252 6.78581 22.3534 6.56738 22.1636C6.34896 21.9702 6.17708 21.7518 6.05176 21.5083C5.93001 21.2612 5.86914 20.9837 5.86914 20.6758C5.86914 20.3428 5.94076 20.0438 6.08398 19.7788C6.22721 19.5103 6.42057 19.2811 6.66406 19.0913C6.90755 18.9051 7.19043 18.7637 7.5127 18.667C7.83854 18.5667 8.1805 18.5166 8.53857 18.5166C8.91813 18.5166 9.27083 18.5757 9.59668 18.6938C9.92611 18.8084 10.2126 18.9696 10.4561 19.1772C10.6995 19.3885 10.8911 19.641 11.0308 19.9346C11.174 20.2246 11.2456 20.5469 11.2456 20.9014H9.96729C9.94938 20.7044 9.90641 20.5254 9.83838 20.3643C9.77393 20.1995 9.68262 20.0581 9.56445 19.9399C9.44271 19.8254 9.29411 19.7358 9.11865 19.6714C8.94678 19.6034 8.74805 19.5693 8.52246 19.5693C8.32552 19.5693 8.1429 19.5962 7.97461 19.6499C7.8099 19.7 7.66667 19.7716 7.54492 19.8647C7.42318 19.9614 7.32829 20.0778 7.26025 20.2139C7.19222 20.3499 7.1582 20.5021 7.1582 20.6704C7.16178 20.8494 7.20833 21.007 7.29785 21.1431C7.38737 21.2756 7.50732 21.3919 7.65771 21.4922C7.81169 21.5924 7.98714 21.6802 8.18408 21.7554C8.3846 21.8306 8.59408 21.9004 8.8125 21.9648C9.08822 22.0436 9.35677 22.1421 9.61816 22.2603C9.88314 22.3748 10.1266 22.5145 10.3486 22.6792C10.6243 22.8869 10.8446 23.1357 11.0093 23.4258C11.1776 23.7122 11.2617 24.0435 11.2617 24.4194C11.2617 24.7668 11.1883 25.0729 11.0415 25.3379C10.8983 25.6029 10.7049 25.8231 10.4614 25.9985C10.2144 26.1812 9.9279 26.319 9.60205 26.4121C9.2762 26.5016 8.93245 26.5464 8.5708 26.5464C8.18766 26.5464 7.8099 26.4873 7.4375 26.3691C7.0651 26.2474 6.74105 26.0719 6.46533 25.8428C6.2111 25.6279 6.00879 25.3755 5.8584 25.0854C5.71159 24.7954 5.63639 24.4624 5.63281 24.0864H6.92188C6.93978 24.3263 6.98991 24.5358 7.07227 24.7148C7.1582 24.8903 7.27458 25.0353 7.42139 25.1499C7.56462 25.2681 7.73291 25.3558 7.92627 25.4131C8.12321 25.4704 8.33805 25.499 8.5708 25.499C8.76774 25.499 8.95036 25.4757 9.11865 25.4292C9.29053 25.3826 9.43913 25.3128 9.56445 25.2197C9.6862 25.1302 9.78288 25.0192 9.85449 24.8867C9.92969 24.7542 9.96729 24.6021 9.96729 24.4302ZM14.0278 18.624L14.9946 21.9702L16.0635 18.624H17.6694V26.4443H16.4556V23.791L16.5308 20.2998L15.3276 24.0327H14.6562L13.5659 20.4287L13.6357 23.791V26.4443H12.4272V18.624H14.0278ZM23.8086 23.1143H20.5V26.4443H19.2002V18.624H24.2812V19.6929H20.5V22.0508H23.8086V23.1143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3170_64659",
    x: 0,
    y: -1,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3170_64659"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3170_64659",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3170_64659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfSmf);
export default __webpack_public_path__ + "static/media/AF-SMF.21f34500a34f0994927d2bfabe4f35b4.svg";
export { ForwardRef as ReactComponent };